const state = {
  bugoptionList: [],
  addBugOptionList: {},
  updateBugOptionList: {},
  deleteBugOptionList: {},
  sendBugOptionPriority: {},
};

export default state;
